import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Smartphone, MessageCircle, Heart, Send } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/pixel';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 bg-zinc-950 overflow-hidden" data-id="element-152">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-600/20 rounded-full blur-[120px] opacity-50 pointer-events-none" data-id="element-153"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10" data-id="element-154">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-12 items-center" data-id="element-155">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left lg:col-span-3" data-id="element-156">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-sm font-medium mb-6" data-id="element-157">
              <span className="relative flex h-2 w-2" data-id="element-158">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" data-id="element-159"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500" data-id="element-160"></span>
              </span>
              Precio lanzamiento: $14.900 ARS
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight text-balance mb-6" data-id="element-161">
              Aprendé a vender iPhones con Meta Ads usando una guía práctica,
              incluso si estás empezando desde cero
            </h1>

            <p className="text-lg md:text-xl text-zinc-400 mb-8 max-w-2xl mx-auto lg:mx-0 text-balance" data-id="element-162">
              Una guía en PDF para aprender a vender iPhones con anuncios de
              Instagram, campañas de mensajes, contenido estratégico, tráfico al
              perfil y análisis de conversaciones reales.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-163">
              <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" onClick={trackInitiateCheckout} className="w-full sm:w-auto px-8 py-4 text-base font-bold text-white bg-blue-600 rounded-full hover:bg-blue-500 transition-all shadow-[0_0_20px_rgba(37,99,235,0.4)] hover:shadow-[0_0_30px_rgba(37,99,235,0.6)] text-center" data-id="element-164">
                Comprar guía ahora
              </a>
              <a href="#temas" className="w-full sm:w-auto px-8 py-4 text-base font-semibold text-white bg-zinc-800 rounded-full hover:bg-zinc-700 transition-colors text-center" data-id="element-165">
                Ver qué incluye
              </a>
            </div>
            <p className="mt-4 text-sm text-zinc-500" data-id="element-166">
              Guía PDF + plantillas + ejemplos listos para adaptar
            </p>
          </motion.div>

          {/* Visual Composite */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative w-full max-w-[400px] mx-auto h-[500px] md:h-[600px] flex items-center justify-center lg:col-span-2" data-id="element-167">
            {/* Dashboard Card (Background left) */}
            <motion.div initial={{
            y: 0
          }} whileInView={{
            y: [0, -10, 0]
          }} viewport={{
            once: false,
            amount: 0.1
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} className="absolute top-10 -left-4 md:-left-12 w-56 md:w-64 bg-zinc-900 rounded-xl shadow-2xl p-4 border border-zinc-800 z-0 hidden sm:block" data-id="element-168">
              <div className="flex items-center gap-2 mb-3" data-id="element-169">
                <BarChart3 className="w-4 h-4 text-blue-500" data-id="element-170" />
                <span className="text-xs font-bold text-zinc-200" data-id="element-171">
                  Rendimiento de Campaña
                </span>
              </div>
              <div className="space-y-3" data-id="element-172">
                <div className="flex justify-between text-xs border-b border-zinc-800 pb-2" data-id="element-173">
                  <span className="text-zinc-400" data-id="element-174">Campaña</span>
                  <span className="font-semibold text-zinc-200" data-id="element-175">
                    iPhone 13 Pro
                  </span>
                </div>
                <div className="flex justify-between text-xs" data-id="element-176">
                  <span className="text-zinc-400" data-id="element-177">CTR</span>
                  <span className="font-semibold text-green-400" data-id="element-178">3.2%</span>
                </div>
                <div className="flex justify-between text-xs" data-id="element-179">
                  <span className="text-zinc-400" data-id="element-180">Mensajes</span>
                  <span className="font-semibold text-zinc-200" data-id="element-181">48</span>
                </div>
                <div className="flex justify-between text-xs" data-id="element-182">
                  <span className="text-zinc-400" data-id="element-183">Costo x Conv.</span>
                  <span className="font-semibold text-green-400" data-id="element-184">$185 ARS</span>
                </div>
              </div>
            </motion.div>

            {/* iPhone Mockup (Center) */}
            <div className="relative w-[260px] md:w-[280px] h-[520px] md:h-[560px] bg-zinc-950 border-[8px] border-zinc-800 rounded-[3rem] shadow-2xl z-10 overflow-hidden flex flex-col" data-id="element-185">
              {/* Notch */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-zinc-800 rounded-b-2xl z-20" data-id="element-186"></div>

              {/* IG Ad Mockup */}
              <div className="flex items-center p-3 pt-10 gap-2 border-b border-zinc-900 bg-zinc-950" data-id="element-187">
                <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-yellow-500 via-red-500 to-purple-500 p-[2px]" data-id="element-188">
                  <div className="w-full h-full bg-zinc-900 rounded-full border border-zinc-950" data-id="element-189"></div>
                </div>
                <div className="flex flex-col" data-id="element-190">
                  <span className="text-[11px] font-bold text-white leading-tight" data-id="element-191">
                    tu_tienda_iphone
                  </span>
                  <span className="text-[9px] text-zinc-400" data-id="element-192">Publicidad</span>
                </div>
              </div>

              {/* Ad Image placeholder */}
              <div className="flex-1 bg-zinc-900 relative overflow-hidden group" data-id="element-193">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-900/40 to-zinc-900 flex flex-col items-center justify-center p-6 text-center" data-id="element-194">
                  <Smartphone className="w-20 h-20 text-blue-500/80 mb-4 drop-shadow-lg" data-id="element-195" />
                  <h3 className="text-white font-bold text-lg leading-tight" data-id="element-196">
                    iPhone 13 Pro
                  </h3>
                  <p className="text-blue-300 text-xs font-medium mt-1" data-id="element-197">
                    Plan Canje Disponible
                  </p>
                </div>
                {/* CTA Bar on Ad */}
                <div className="absolute bottom-0 left-0 right-0 bg-blue-600 py-2 px-4 flex justify-between items-center" data-id="element-198">
                  <span className="text-[10px] font-bold text-white uppercase tracking-wider" data-id="element-199">
                    Enviar mensaje
                  </span>
                  <Send className="w-3 h-3 text-white" data-id="element-200" />
                </div>
              </div>

              {/* IG Actions */}
              <div className="p-3 bg-zinc-950 space-y-2" data-id="element-201">
                <div className="flex gap-3" data-id="element-202">
                  <Heart className="w-5 h-5 text-zinc-300" data-id="element-203" />
                  <MessageCircle className="w-5 h-5 text-zinc-300" data-id="element-204" />
                  <Send className="w-5 h-5 text-zinc-300" data-id="element-205" />
                </div>
                <div className="space-y-1" data-id="element-206">
                  <p className="text-[10px] text-white" data-id="element-207">
                    <span className="font-bold" data-id="element-208">tu_tienda_iphone</span> Entregá
                    tu equipo usado como parte de pago...
                  </p>
                </div>
              </div>
            </div>

            {/* Chat Bubble (Foreground right) */}
            <motion.div initial={{
            y: 0
          }} whileInView={{
            y: [0, 8, 0]
          }} viewport={{
            once: false,
            amount: 0.1
          }} transition={{
            repeat: Infinity,
            duration: 5,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute bottom-12 -right-4 md:-right-12 w-64 md:w-72 bg-green-600 rounded-2xl rounded-br-sm shadow-xl p-3 z-20 text-white border border-green-500" data-id="element-209">
              <p className="text-xs md:text-sm leading-relaxed font-medium" data-id="element-210">
                "Hola, vi el iPhone 13 con plan canje. Tengo un 11 para entregar
                y $250.000 en efectivo. ¿Tienen stock?"
              </p>
              <div className="flex justify-end items-center gap-1 mt-1" data-id="element-211">
                <span className="text-[9px] text-green-200" data-id="element-212">10:42 AM</span>
                <svg className="w-3 h-3 text-green-200" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-213">
                  <polyline points="20 6 9 17 4 12" data-id="element-214"></polyline>
                </svg>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}